import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;

class SCMRangePicker extends React.Component {
  render() {
    const { hasTomorrow, isMarket, customRanges } = this.props;
    let ranges = {
      今天: [moment().startOf('days'), moment().endOf('days')],
      昨天: [
        moment().subtract(1, 'days').startOf('days'),
        moment().subtract(1, 'days').endOf('days'),
      ],
      近7天: [moment().subtract(6, 'days').startOf('days'), moment().endOf('days')],
      近14天: [moment().subtract(13, 'days').startOf('days'), moment().endOf('days')],
      近30天: [moment().subtract(29, 'days').startOf('days'), moment().endOf('days')],
      当月: [moment().startOf('month'), moment().endOf('month')],
      上个月: [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ],
      未来一个月: [moment(), moment().add(30, 'days')],
    };
    if (hasTomorrow) {
      ranges = Object.assign(
        { 明天: [moment().add(1, 'days').startOf('days'), moment().add(1, 'days').endOf('days')] },
        ranges,
      );
    } else if (isMarket) {
      ranges = {
        今天: [moment().startOf('days'), moment().endOf('days')],
        昨天: [
          moment().subtract(1, 'days').startOf('days'),
          moment().subtract(1, 'days').endOf('days'),
        ],
        近7天: [moment().subtract(6, 'days').startOf('days'), moment().endOf('days')],
      };
    }
    return (
      <RangePicker
        ranges={customRanges ? customRanges : ranges}
        style={{ width: '100%' }}
        {...this.props}
      />
    );
  }
}

export default SCMRangePicker;
